<script>
import Layout from "../../../layouts/main";
// import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loader from "@/components/widgets/loader";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Vue from "vue";
// import Vuetable from "vuetable-2";
// import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import {FulfillingBouncingCircleSpinner} from "epic-spinners";
// import { helpers } from "../../../../helpers/helpers-validate";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
// import MaskedInput from "vue-text-mask";
// import Switches from "vue-switches";

Vue.component("v-select", vSelect);
// register the plugin on vue
import Toasted from "vue-toasted";
import {
  authMethods,
  authFackMethods,
  notificationMethods
} from "@/state/helpers";
import {mapState} from "vuex";
import {authComputed} from "@/state/helpers";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.
// let nit = (value) => helpers.nitIsValid(value);
// let correo = (value) => helpers.correo(value);
/**
 * new orden component
 */
export default {
  page: {
    title: "Corte de caja",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    Layout,
    // PageHeader,
    DatePicker,
    // Switches,
    // Vuetable,
    // VuetablePagination,
    // Loader,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    // "masked-input": MaskedInput,
  },
  data() {
    return {
      userT: this.$store.state.authfack.user,
      arrayUsuarios: [],
      datos: null,
      disabledUser: true,
      disabledDate: true,
      formCaja: {
        fecha_caja: null,
        cajero: null,
        tienda: "",
        state: true,
        id: 0,
      },
      mask_quetzal: createNumberMask({
        prefix: "Q ",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
      // Otros datos
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token}
      },
      apiUrl: process.env.VUE_APP_URL,
      apiBase:
          process.env.VUE_APP_URL +
          "productos/stock/busqueda?departamento=" +
          0 +
          "&estante=" +
          0,
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      // title: "CORTE DE CAJA",
      // items: [
      //   {
      //     text: "Caja",
      //     href: "/",
      //   },
      //   {
      //     text: "Corte de caja",
      //     active: true,
      //   },
      // ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      showModalL: false, //Loading
      showModalNP: false, //Nuevo cliente
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
    };
  },
  validations: {
    // formCaja: {
    //   fecha_venta: { required },
    //   tienda: { required },
    //   cliente: { required },
    //   venta: { required },
    //   total: { required },
    // },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: {"x-token": usuario.token},
      })
          .then((res) => {
            if (res.data.success) {
              // this.$router.push("/");
            }
          })
          .catch(() => {
            this.logout();
            location.reload();
          });
    }
    // this.detalle();
    this.getUsuarios();
    this.gettienda();
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    calcularTotal: function () {
      let resultado = 0.0;
      if (this.detalleorden.length > 0) {
        for (let i = 0; i < this.detalleorden.length; i++) {
          resultado = resultado + parseFloat(this.detalleorden[i].subtotal);
        }
      }
      return resultado.toFixed(2);
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    corteCajero() {
      this.datos = null;
      this.formCaja.cajero = null;
      this.formCaja.fecha_caja = new Date();
      this.disabledUser = true;
      this.disabledDate = false;
    },
    corteDia() {
      this.datos = null;
      this.formCaja.cajero = null;
      this.formCaja.fecha_caja = null;
      this.disabledUser = false;
      this.disabledDate = true;
    },
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
            number.charAt(i) === "Q" ||
            number.charAt(i) === "€" ||
            number.charAt(i) === "$" ||
            number.charAt(i) === "%" ||
            number.charAt(i) === "," ||
            number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },

    async getDatosUsuario() {
      this.datos = null;
      try {
        const response = await axios.get(
            process.env.VUE_APP_URL +
            "caja/cierre_general_usuario?fecha=" +
            this.customFormatter(this.formCaja.fecha_caja) +
            "&usuario=" +
            this.formCaja.cajero.id,
            {
              headers: {"x-token": this.userT.token},
            }
        );
        this.datos = response.data;
        // console.log(this.datos);
      } catch (error) {
        console.log(error);
      }
    },
    async getDatosFecha() {
      this.datos = null;
      try {
        const response = await axios.get(
            process.env.VUE_APP_URL +
            "caja/cierre_general?fecha=" +
            this.customFormatter(this.formCaja.fecha_caja),
            {
              headers: {"x-token": this.userT.token},
            }
        );
        this.datos = response.data;
        // console.log(this.datos);
      } catch (error) {
        console.log(error);
      }
    },
    async gettienda() {
      let me = this;
      me.formCaja.tienda = "";
      axios
          .get(process.env.VUE_APP_URL + "tiendas/select", {
            headers: {"x-token": this.userT.token},
          })
          .then(function (response) {
            me.formCaja.tienda = response.data[0].id;
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    async getUsuarios() {
      let me = this;
      this.arrayUsuarios = [];
      try {
        const response = await axios.get(this.apiUrl + "users/get_usuarios_cajeros", {
          headers: {"x-token": this.userT.token},
        });
        me.arrayUsuarios = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<template>
  <Layout>
    <!-- Modal loading -->
    <b-modal
        centered
        v-model="showModalL"
        title-class="text-black font-18"
        body-class="p-3"
        hide-footer
        no-close-on-backdrop
        content-class="my-class"
        header-class="my-class"
    >
      <template #modal-header="{}">
        <!-- Emulate built in modal header close button action -->

        <h5></h5>
      </template>
      <form>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <fulfilling-bouncing-circle-spinner
                  :animation-duration="2000"
                  :size="90"
                  color="#2a3042"
              />
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <!-- <PageHeader :title="title" :items="items" /> -->
    <!-- ESTA PARTE ES PARA LA CABECERA -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center">
              <div class="mb-4">
                <h2>CORTE CAJA</h2>
              </div>
            </div>
            <div class="row" align="center">
              <div class="col">
                <div class="row">
                  <div class="col d-grid gap-2">
                    <b-button
                        block
                        size="lg"
                        :variant="
                        disabledUser == false ? 'outline-secondary' : 'success'
                      "
                        @click="corteCajero()"
                    >
                      CORTE DE CAJERO&nbsp;&nbsp;<i class="bx bx-user"></i>
                    </b-button>
                  </div>
                  <div class="col d-grid gap-2">
                    <b-button
                        block
                        size="lg"
                        :variant="
                        disabledDate == false ? 'outline-secondary' : 'success'
                      "
                        @click="corteDia()"
                    >
                      CORTE DEL DÍA&nbsp;&nbsp;<i
                        class="bx bx-calendar-check"
                    ></i>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
            <hr/>
            <div class="text-center">
              <div>
                <div class="row">
                  <div v-if="!disabledDate" class="col-md-2" align="left">
                    <h2>Corte de</h2>
                  </div>
                  <div v-if="!disabledUser" class="col-md-2" align="left">
                    <h2>Corte del</h2>
                  </div>
                  <div v-if="!disabledDate" class="col-md-4">
                    <v-select
                        :disabled="!disabledUser"
                        v-model.trim="formCaja.cajero"
                        :options="arrayUsuarios"
                        @search="getUsuarios"
                        @input="getDatosUsuario"
                        placeholder="Seleccionar usuario"
                        label="usuario"
                    >
                      <template v-slot:option="options">
                        {{
                          options.usuario +
                          " | " +
                          options.empleado.persona.nombre_persona +
                          " " +
                          options.empleado.persona.apellido_persona
                        }}
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        {{
                          option.usuario +
                          " | " +
                          option.empleado.persona.nombre_persona +
                          " " +
                          option.empleado.persona.apellido_persona
                        }}
                      </template>
                    </v-select>
                  </div>
                  <div v-if="!disabledDate" class="col-md-2" align="left">
                    <h2>del</h2>
                  </div>
                  <div v-show="disabledUser || disabledDate" class="col">
                    <date-picker
                        v-if="!disabledUser"
                        v-model="formCaja.fecha_caja"
                        @input="getDatosFecha"
                        placeholder="Seleccione una fecha"
                        :first-day-of-week="1"
                    ></date-picker>
                    <date-picker
                        v-if="!disabledDate"
                        v-model="formCaja.fecha_caja"
                        @input="getDatosUsuario"
                        placeholder="Seleccione una fecha"
                        :first-day-of-week="1"
                    ></date-picker>
                  </div>
                </div>
                <hr v-if="!disabledDate || !disabledUser"/>
                <!-- Seleccion-->
                <div v-if="datos">
                  <div class="row">
                    <div class="col">
                      <b-card bg-variant="primary">
                        <div class="row">
                          <div class="col" align="left">
                            <h3 class="text-white">
                              <i class="bx bx-money"></i>&nbsp;&nbsp;Ganancias
                            </h3>
                          </div>
                          <div class="col" align="right">
                            <h3 class="text-white">
                              <strong>
                                {{ money(datos.ganancias ? datos.ganancias : 0.0) }}
                              </strong>
                            </h3>
                          </div>
                        </div>
                      </b-card>
                    </div>
                    <div class="col">
                      <b-card bg-variant="primary">
                        <div class="row">
                          <div class="col" align="left">
                            <h3 class="text-white">
                              <i class="bx bx-stats"></i>&nbsp;&nbsp;Inversiones
                            </h3>
                          </div>
                          <div class="col" align="right">
                            <h3 class="text-white">
                              <strong>
                                {{ money(datos.inversiones ? datos.inversiones : 0.0) }}
                              </strong>
                            </h3>
                          </div>
                        </div>
                      </b-card>
                    </div>
                  </div>
                  <!-- Cards dinero y ventas -->
                  <div class="row">
                    <div class="col">
                      <b-card>
                        <h3 align="left">
                          <i class="bx bxl-product-hunt"></i>&nbsp;&nbsp;Ventas
                          de producto
                        </h3>
                        <br/>
                        <b-row>
                          <b-col align="left"><h4>TOTAL:</h4></b-col>
                          <b-col align="right">
                            <h4>
                              {{ money(datos.totalVentas ? datos.totalVentas : 0.0) }}
                            </h4>
                          </b-col>
                        </b-row>
                      </b-card>
                    </div>
                    <div class="col">
                      <b-card>
                        <h3 align="left">
                          <i class="bx bx-wrench"></i>&nbsp;&nbsp;Ventas de
                          servicio
                        </h3>
                        <br/>
                        <b-row>
                          <b-col align="left"><h4>TOTAL:</h4></b-col>
                          <b-col align="right">
                            <h4>
                              {{ money(datos.servicios ? datos.servicios : 0.0) }}
                            </h4>
                          </b-col>
                        </b-row>
                      </b-card>
                    </div>
                    <div class="col">
                      <b-card>
                        <h3 align="left">
                          <i class="bx bx-calculator"></i>&nbsp;&nbsp;Total en
                          caja
                        </h3>
                        <br/>
                        <b-row>
                          <b-col align="left"><h4>TOTAL:</h4></b-col>
                          <b-col align="right">
                            <h4>
                              {{ money(datos.caja.fin_caja ? datos.caja.fin_caja : 0.0) }}
                            </h4>
                          </b-col>
                        </b-row>
                      </b-card>
                    </div>
                    <div class="col">
                      <b-card>
                        <h3 align="left">
                          <i class="bx bx-user-plus"></i>&nbsp;&nbsp;Pagos de
                          crédito
                        </h3>
                        <br/>
                        <b-row>
                          <b-col align="left"><h4>TOTAL:</h4></b-col>
                          <b-col align="right">
                            <h4>
                              {{ money(datos.caja.fin_abonos ? datos.caja.fin_abonos : 0.0) }}
                            </h4>
                          </b-col>
                        </b-row>
                      </b-card>
                    </div>
                  </div>
                  <!-- Cards efectivo -->
                  <b-card v-b-toggle.accordion-1>
                    <h3 align="left">
                      <i class="fas fa-money-bill"></i>&nbsp;&nbsp;Efectivo
                    </h3>
                  </b-card>
                  <b-collapse id="accordion-1">
                    <div class="row">
                      <div class="col">
                        <b-card>
                          <h3 align="left">
                            <i class="bx bx-upvote"></i>&nbsp;&nbsp;Ingresados
                          </h3>
                          <br/>
                          <b-row>
                            <b-col align="left"><h4>TOTAL:</h4></b-col>
                            <b-col align="right">
                              <h4>
                                {{ money(datos.caja.fin_caja_efectivo ? datos.caja.fin_caja_efectivo : 0.0) }}
                              </h4>
                            </b-col>
                          </b-row>
                        </b-card>
                      </div>
                      <div class="col">
                        <b-card>
                          <h3 align="left">
                            <i class="bx bx-downvote"></i>&nbsp;&nbsp;Sistema
                          </h3>
                          <br/>
                          <b-row>
                            <b-col align="left"><h4>TOTAL:</h4></b-col>
                            <b-col align="right">
                              <h4>
                                {{ money(datos.caja.fin_sistema_efectivo ? datos.caja.fin_sistema_efectivo : 0.0) }}
                              </h4>
                            </b-col>
                          </b-row>
                        </b-card>
                      </div>
                    </div>
                  </b-collapse>
                  <!-- Cards transferencia -->
                  <b-card v-b-toggle.accordion-2>
                    <h3 align="left">
                      <i class="bx bx-transfer-alt"></i
                      >&nbsp;&nbsp;Transferencia
                    </h3>
                  </b-card>
                  <b-collapse id="accordion-2">
                    <div class="row">
                      <div class="col">
                        <b-card>
                          <h3 align="left">
                            <i class="bx bx-upvote"></i>&nbsp;&nbsp;Ingresados
                          </h3>
                          <br/>
                          <b-row>
                            <b-col align="left"><h4>TOTAL:</h4></b-col>
                            <b-col align="right">
                              <h4>
                                {{ money(datos.caja.fin_caja_transferencias ? datos.caja.fin_caja_transferencias : 0.0) }}
                              </h4>
                            </b-col>
                          </b-row>
                        </b-card>
                      </div>
                      <div class="col">
                        <b-card>
                          <h3 align="left">
                            <i class="bx bx-downvote"></i>&nbsp;&nbsp;Sistema
                          </h3>
                          <br/>
                          <b-row>
                            <b-col align="left"><h4>TOTAL:</h4></b-col>
                            <b-col align="right">
                              <h4>
                                {{
                                  money(datos.caja.fin_sistema_transferencia ? datos.caja.fin_sistema_transferencia : 0.0)
                                }}
                              </h4>
                            </b-col>
                          </b-row>
                        </b-card>
                      </div>
                    </div>
                  </b-collapse>
                  <!-- Cards deposito -->
                  <b-card v-b-toggle.accordion-3>
                    <h3 align="left">
                      <i class="bx bxs-downvote"></i>&nbsp;&nbsp;Deposito
                    </h3>
                  </b-card>
                  <b-collapse id="accordion-3">
                    <div class="row">
                      <div class="col">
                        <b-card>
                          <h3 align="left">
                            <i class="bx bx-upvote"></i>&nbsp;&nbsp;Ingresados
                          </h3>
                          <br/>
                          <b-row>
                            <b-col align="left"><h4>TOTAL:</h4></b-col>
                            <b-col align="right">
                              <h4>
                                {{ money(datos.caja.fin_caja_depositos ? datos.caja.fin_caja_depositos : 0.0) }}
                              </h4>
                            </b-col>
                          </b-row>
                        </b-card>
                      </div>
                      <div class="col">
                        <b-card>
                          <h3 align="left">
                            <i class="bx bx-downvote"></i>&nbsp;&nbsp;Sistema
                          </h3>
                          <br/>
                          <b-row>
                            <b-col align="left"><h4>TOTAL:</h4></b-col>
                            <b-col align="right">
                              <h4>
                                {{ money(datos.caja.fin_sistema_deposito ? datos.caja.fin_sistema_deposito : 0.0) }}
                              </h4>
                            </b-col>
                          </b-row>
                        </b-card>
                      </div>
                    </div>
                  </b-collapse>
                  <!-- Cards tarjeta -->
                  <b-card v-b-toggle.accordion-5>
                    <h3 align="left">
                      <i class="far fa-credit-card"></i>&nbsp;&nbsp;Tarjeta
                    </h3>
                  </b-card>
                  <b-collapse id="accordion-5">
                    <div class="row">
                      <div class="col">
                        <b-card>
                          <h3 align="left">
                            <i class="bx bx-upvote"></i>&nbsp;&nbsp;Ingresados
                          </h3>
                          <br/>
                          <b-row>
                            <b-col align="left"><h4>TOTAL:</h4></b-col>
                            <b-col align="right">
                              <h4>
                                {{ money(datos.caja.fin_caja_tarjeta ? datos.caja.fin_caja_tarjeta : 0.0) }}
                              </h4>
                            </b-col>
                          </b-row>
                        </b-card>
                      </div>
                      <div class="col">
                        <b-card>
                          <h3 align="left">
                            <i class="bx bx-downvote"></i>&nbsp;&nbsp;Sistema
                          </h3>
                          <br/>
                          <b-row>
                            <b-col align="left"><h4>TOTAL:</h4></b-col>
                            <b-col align="right">
                              <h4>
                                {{ money(datos.caja.fin_sistema_tarjeta ? datos.caja.fin_sistema_tarjeta : 0.0) }}
                              </h4>
                            </b-col>
                          </b-row>
                        </b-card>
                      </div>
                    </div>
                  </b-collapse>
                  <!-- Cards cheque -->
                  <b-card v-b-toggle.accordion-4>
                    <h3 align="left">
                      <i class="bx bx-dock-top"></i>&nbsp;&nbsp;Cheque
                    </h3>
                  </b-card>
                  <b-collapse id="accordion-4">
                    <div class="row">
                      <!-- <div class="col">
                        <b-card>
                          <h3 align="left">
                            <i class="bx bx-upvote"></i>&nbsp;&nbsp;Ingresados
                          </h3>
                          <br />
                          <b-row>
                          <b-col align="left"><h4>TOTAL:</h4></b-col>
                          <b-col align="right">
                            <h4>
                              {{ money(datos.caja.fin_caja_transferencias) }}
                            </h4>
                          </b-col>
                        </b-row>
                        </b-card>
                      </div> -->
                      <div class="col">
                        <b-card>
                          <h3 align="left">
                            <i class="bx bx-downvote"></i>&nbsp;&nbsp;Sistema
                          </h3>
                          <br/>
                          <b-row>
                            <b-col align="left"><h4>TOTAL:</h4></b-col>
                            <b-col align="right">
                              <h4>
                                {{ money(datos.caja.fin_sistema_cheque ? datos.caja.fin_sistema_cheque : 0.0) }}
                              </h4>
                            </b-col>
                          </b-row>
                        </b-card>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
